module.exports = __webpack_public_path__ + "img/markerXY.d2e40748.png";